import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'

type Reporter = {
  warn: (message?: any, ...optionalParams: any[]) => void
  error: (message?: any, ...optionalParams: any[]) => void
}

class RealReporter implements Reporter {
  warn = (message: any, ...optionalParams: any[]): void => console.warn(message, ...optionalParams)
  error = (message: any, ...optionalParams: any[]): void => console.error(message, ...optionalParams)
}

export class FakeReporter implements Reporter {
  warnCalls: {message: any, optionalParams: any[]}[] = []
  errorCalls: {message: any, optionalParams: any[]}[] = []

  warn = (message: any, ...optionalParams: any[]): void => {
    this.warnCalls.push({ message, optionalParams })
  }

  error = (message: any, ...optionalParams: any[]): void => {
    this.errorCalls.push({ message, optionalParams })
  }
}

export let reporter: Reporter
registerDependency({
  [REAL]: () => reporter = new RealReporter(),
  [FAKE]: () => reporter = new FakeReporter(),
})
